export const checkinEditDrawer = {
  header: {
    title: "Editar datos del Check-in",
    age: "Edad:",
    docNotRequiredMinor: "Documento no requerido (menor)",
    docOptionalMinorES: "Documento opcional (menor en España)",
    docOptionalMinorCO: "Documento opcional (menor < 7 en Colombia)",
  },
  sections: {
    basicData: "Datos básicos",
    stayDates: "Fechas de hospedaje",
    italyDoc: "Documento y país de nacimiento",
    doc: "Documento y nacionalidad",
  },
  fields: {
    firstName: "Nombre",
    lastName: "Apellido",
    email: "Email",
    phone: "Teléfono",
    birthDate: "Fecha de nacimiento",
    sex: "Género",
    checkIn: "Entrada",
    checkOut: "Salida",
    docType: "Tipo de documento",
    docNumber: "Número de documento",
    supportNumber: "Número de soporte",
    nationality: "Nacionalidad",
  },
  placeholders: {
    select: "Seleccionar",
    selectNationality: "Seleccionar nacionalidad",
    searchCountry: "Buscar país...",
    selectCountry: "— seleccionar país —",
    docNumberExample: "Ej: AB1234567",
    docNumberGeneric: "DNI / NIE / Pasaporte",
    required: "Obligatorio",
    optional: "Opcional",
  },
  sex: {
    male: "Masculino",
    female: "Femenino",
    preferNotToSay: "Prefiero no decirlo",
    other: "Otro",
  },
  italy: {
    badge: "Alloggiati Web",
    birthCountryLabel: "País de nacimiento",
    birthCountryHint: "— también se usa como ciudadanía",
    issuePlaceLabel: "Lugar de expedición del documento",
    issuePlaceHint: "— país donde se emitió el documento",
    alloggiatiCode: "Código Alloggiati:",
    iso3Label: "ISO3:",
    minorNote:
      "Menor de edad — tipo de documento, número y lugar de expedición se envían en blanco a Alloggiati Web (TABELLA 1).",
  },
  hints: {
    docOptional:
      "Documento opcional por regla de edad/país. Puedes completarlo igualmente.",
  },
  docTypes: {
    it: {
      IDENT: "Documento de identidad (IDENT)",
      IDELE: "Documento de identidad electrónico (IDELE)",
      PASOR: "Pasaporte ordinario (PASOR)",
      PASSE: "Pasaporte de servicio (PASSE)",
      PASDI: "Pasaporte diplomático (PASDI)",
      PATEN: "Permiso de conducir (PATEN)",
      PATNA: "Permiso náutico (PATNA)",
      CIDIP: "ID diplomático (CIDIP)",
      RIFUG: "Título viaje refugiado (RIFUG)",
    },
    co: {
      CC: "Cédula de Ciudadanía",
      CE: "Cédula de Extranjería",
      P: "Pasaporte",
      PPT: "Permiso por Protección Temporal",
      PEP: "Permiso Especial de Permanencia",
      DE: "Documento Extranjero",
      CD: "Carné Diplomático",
    },
    es: {
      ID: "DNI",
      IM: "NIE",
      P: "Pasaporte",
      OTRO: "Otro",
    },
    generic: {
      ID: "Documento de identidad",
      P: "Pasaporte",
      OTRO: "Otro",
    },
  },
  footer: {
    cancel: "Cancelar",
    save: "Guardar",
    saving: "Guardando...",
  },
  errors: {
    nameRequired: "Nombre y apellido son obligatorios.",
    emailInvalid: "Email inválido.",
    phoneRequired: "Teléfono es obligatorio.",
    birthDateRequired: "Fecha de nacimiento es obligatoria.",
    sexRequired: "Género es obligatorio.",
    stayDatesRequired: "Fechas de hospedaje son obligatorias.",
    checkoutBeforeCheckin: "La fecha de salida no puede ser menor a la de entrada.",
    birthCountryRequired: "País de nacimiento es obligatorio.",
    docTypeRequired: "Tipo de documento es obligatorio.",
    docNumberRequired: "Número de documento es obligatorio.",
    issuePlaceRequired: "Lugar de expedición del documento es obligatorio.",
    nationalityRequired: "Nacionalidad es obligatoria.",
    supportNumberRequired:
      "Número de soporte es obligatorio para nacionalidad española (mayor de edad).",
    saveFailed: "No se pudo guardar.",
    saveError: "Error guardando cambios.",
  },
  toast: {
    saved: "Check-in actualizado correctamente",
  },
};
